import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { subscriptionService } from '../../services';
import { FEED_QUERY_KEY } from './useFeed';
import { SAVED_QUERY_KEY } from './useSaved';
import { CREATOR_PROFILE_QUERY_KEY } from './useCreatorProfile';

export const SUBSCRIPTIONS_QUERY_KEY = 'subscriptions';

export function useSubscriptions(enabled = true) {
  return useQuery({
    queryKey: [SUBSCRIPTIONS_QUERY_KEY],
    queryFn: () => subscriptionService.getSubscriptions(),
    enabled,
  });
}

export function useSubscribe() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ creatorId, tier }) => subscriptionService.subscribe(creatorId, tier),
    onSuccess: () => {
      queryClient.invalidateQueries([SUBSCRIPTIONS_QUERY_KEY]);
      queryClient.invalidateQueries([FEED_QUERY_KEY]);
      queryClient.invalidateQueries([CREATOR_PROFILE_QUERY_KEY]);
    },
  });
}

export function useUnsubscribe() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (subscriptionId) => subscriptionService.unsubscribe(subscriptionId),
    onSuccess: () => {
      queryClient.invalidateQueries([SUBSCRIPTIONS_QUERY_KEY]);
      queryClient.invalidateQueries([FEED_QUERY_KEY]);
      queryClient.invalidateQueries([SAVED_QUERY_KEY]);
    },
  });
}
